import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdMessage, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked, MdWhatsapp } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE_PHONE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INTRO_1,
  STR_INTRO_2,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_WELCOME
} from "../Strings";
import logo from "../assets/logo.png";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("launch");

  async function init() {
    //..
  }

  async function getStarted() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div
      className="Login"
    >
      
      
      {
        loginStep === "launch" && (
          <div className="launch">

            <div className="login-sections">

              {/* LEFT SECTION — transparent */}
              <div className="section-left">
                {/* Optional content */}
              </div>

              {/* RIGHT SECTION — colored */}
              <div className="section-right">

                <div className="login-card">

                  <div className="text-center">
                    <img src={logo} width="120" height="auto" />
                  </div>

                  <div className="text-center">
                    <h6
                      className="font-bold text-dark text-center mb-4"
                      style={{
                        fontSize: "32px",
                        padding: "6px",
                        borderRadius: "10px",
                      }}
                    >
                      Abiary Computers
                    </h6>
                  </div>

                  <div className="">
                    <button
                      className="btn btn-secondary btn-block btn-padded"
                      onClick={getStarted}
                      style={{
                        flexShrink: 0,
                      }}
                    >
                      {STR_GET_STARTED[appContext.language]}
                    </button>

                    
                  </div>

                  <h6
                    className="font-semi-bold text-center mb-4 mt-4 d-none"
                    style={{ 
                      fontSize: "14px",
                      textTransform: "uppercase",
                    }}
                  >
                    {STR_INTRO_2[appContext.language]}
                  </h6>

                  

                </div>

              </div>

            </div>

          </div>
        )
      }

      

    </div >
  )
}